<div class="container-fluid">
    <app-breadcrumb
        [title]="'Suivi des opérations'"
        [active_item]="'Réclamations'"
    ></app-breadcrumb>
    <div class="card" [ngStyle]="{ 'border-radius': '10px' }">
        <div class="card-body">
            <div style="margin-top: -2rem !important">
                <app-patrimoine-header
                    [displayDate]="false"
                    [count]="listTraitemants"
                    [total]="totalRecords"
                    [legendePluriel]="'dossiers en réclamations'"
                    [legendeSingulier]="'dossiers en réclamations'"
                >
                </app-patrimoine-header>
            </div>
            <div class="row filter_wrapper">
                <div class="col-md-2">
                    <div class="form-group">
                        <label><b>Type opération</b></label>
                        <p-dropdown
                            [options]="listOperations"
                            [showClear]="true"
                            [(ngModel)]="selectedTypeOperation"
                            placeholder="Opération"
                        >
                            <ng-template let-data pTemplate="item">
                                <div class="country-item">
                                    <div>{{ data | titlecase }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>
                            <b>N° Dossier</b>
                        </label>
                        <input
                            placeholder="Demande"
                            [(ngModel)]="selectedTransaction"
                            type="text"
                            pInputText
                        />
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="block"><b>Demandeur</b></label>
                    <p-dropdown
                        [options]="listUsers"
                        [(ngModel)]="currentUser"
                        optionLabel="fullName"
                        [filter]="true"
                        filterBy="fullName"
                        [showClear]="true"
                        placeholder="demandeur"
                    >
                        <ng-template let-data pTemplate="item">
                            <div class="country-item">
                                <div>{{ data.fullName }}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="col-md-2">
                    <label class="block"><b>Date début</b></label>
                    <p-calendar
                        [(ngModel)]="filterDateStart"
                        [showIcon]="true"
                        (ngModelChange)="changeDateStart($event)"
                        dateFormat="dd-mm-yy"
                        [showButtonBar]="true"
                    ></p-calendar>
                </div>
                <div class="col-md-2">
                    <label class="block"><b>Date fin </b></label>
                    <p-calendar
                        [(ngModel)]="filterDateEnd"
                        [showIcon]="true"
                        [showClear]="true"
                        (ngModelChange)="changeDateEnd($event)"
                        dateFormat="dd-mm-yy"
                        [showButtonBar]="true"
                    ></p-calendar>
                </div>
                <div
                    class="p-0"
                    [ngStyle]="{ width: '4rem' }"
                    *ngIf="!secondFilter"
                >
                    <label [ngStyle]="{ opacity: '0' }">Actions</label> <br />
                    <p-button
                        styleClass="p-button-success"
                        icon="pi pi-filter"
                        (click)="onFilter()"
                        [disabled]="isFilter()"
                    ></p-button>
                </div>
            </div>
            <div class="table_content_wrapper">
                <div class="table_actions_wrapper pt-2">
                    <button
                        pButton
                        pRipple
                        label="Rafraîchir"
                        (click)="OnRefresh()"
                        icon="pi pi-refresh"
                        class="p-button-secondary"
                    ></button>
                    <button
                        pButton
                        pRipple
                        label="Exporter"
                        (click)="OnExportExcel()"
                        icon="pi pi-download"
                        [disabled]="disableAction()"
                        class="p-button-helf"
                    ></button>
                </div>
                <div class="d-flex gap-3">
                    <div class="table_header__legende">
                        <app-table-header
                            [count]="listTraitemants"
                            [legende]="'Réclamations'"
                            [page]="page"
                            [totalPage]="totalPage"
                        ></app-table-header>
                    </div>
                </div>
                <table [ngClass]="['native_table table']">
                    <thead>
                        <th class="text-center" [style]="{ width: '1.5rem' }">
                            #
                        </th>
                        <th class="text-center">Date / Heure</th>
                        <th class="text-center" [ngStyle]="{ width: '200px' }">
                            N° Dossier
                        </th>
                        <th class="text-center">Service</th>
                        <th class="text-center">Rapport</th>
                        <th class="text-center">Détails Rapport</th>
                        <th class="text-center">Statut</th>
                        <th class="text-center">Demandeur</th>
                        <th class="text-center" [ngStyle]="{ width: '150px' }">
                            Date Traitement
                        </th>
                        <th class="text-center">Intervenant</th>
                        <th class="text-center" [style]="{ width: '3rem' }">
                            Actions
                        </th>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="
                                let transaction of listTraitemants
                                    | paginate
                                        : {
                                              itemsPerPage: recordsPerPage,
                                              currentPage: p,
                                              totalPages: totalPage,
                                              totalItems: totalRecords
                                          };
                                let i = index
                            "
                        >
                            <td class="text-center">{{ this.offset + i }}</td>
                            <td [style]="{ width: '10rem' }">
                                {{ transaction?.created_at }}
                            </td>
                            <td
                                class="cursor-pointer text-center"
                                (click)="
                                    copyTransaction(transaction.transaction)
                                "
                            >
                                {{ transaction.transaction }}
                            </td>
                            <td class="text-center">
                                {{
                                    getTitleForm(
                                        transaction?.operation ?? 'N/A'
                                    )
                                }}
                            </td>
                            <td class="text-center">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    [class.text-white]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '200' ||
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === 'false'
                                    "
                                    [class.badge-dark]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '100'
                                    "
                                    [class.badge-info]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '102'
                                    "
                                    [class.badge-success]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === '200'
                                    "
                                    [class.badge-danger]="
                                        getCodeRapport(
                                            transaction?.code_rapport
                                        ) === 'false'
                                    "
                                    class="badge"
                                >
                                    {{ transaction.code_rapport }}
                                </span>
                            </td>
                            <td
                                class="cursor-pointer"
                                [innerHTML]="transaction?.message"
                                (click)="showDialog(transaction)"
                                pTooltip="cliquer pour voir"
                                tooltipPosition="top"
                            >
                                {{ truncateString(transaction?.message, 20) }}
                            </td>
                            <td class="text-center">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    class="badge"
                                    [class.badge-dark]="
                                        transaction?.statut === stateSoumis
                                    "
                                    [class.badge-info]="
                                        transaction?.statut === stateTraite
                                    "
                                    [class.badge-success]="
                                        transaction?.statut === stateCloture
                                    "
                                >
                                    {{ transaction.statut }}
                                </span>
                            </td>
                            <td class="text-center">
                                <span
                                    [ngStyle]="{ 'font-size': '16px' }"
                                    class="badge"
                                    [class.badge-dark]="
                                        transaction?.traitement ===
                                            treatmenEntente ||
                                        transaction?.traitement ===
                                            treatmenAcquiter
                                    "
                                    [class.badge-danger]="
                                        transaction?.traitement ===
                                            treatmenRejeter ||
                                        transaction?.traitement ===
                                            treatmenRefuser
                                    "
                                    [class.badge-warning]="
                                        transaction?.traitement ===
                                        treatmenCancel
                                    "
                                    [class.badge-info]="
                                        transaction?.traitement ===
                                        treatmenAccepter
                                    "
                                    [class.badge-success]="
                                        transaction?.statut === stateCloture &&
                                        transaction?.traitement ===
                                            treatmenAccepter
                                    "
                                >
                                    {{ transaction.traitement }}
                                </span>
                            </td>
                            <td>
                                <span>
                                    {{ transaction?.current_date }}
                                </span>
                            </td>
                            <td class="text-center">
                                <span>
                                    {{ transaction?.demandeur_nom }}
                                    {{ transaction?.demandeur_prenoms }}
                                </span>
                            </td>
                            <td style="text-align: center">
                                <button
                                    pButton
                                    pRipple
                                    icon="pi pi-eye"
                                    class="p-button-dark"
                                    pTooltip="Voir"
                                    tooltipPosition="top"
                                    (click)="OnShowTraitement(transaction)"
                                ></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div [ngClass]="['pagination-controls']">
                    <pagination-controls
                        (pageChange)="onPageChange($event)"
                        previousLabel=""
                        nextLabel=""
                    >
                    </pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="progress-spinner" *ngIf="IsLoading">
    <p-progressSpinner
        [style]="{ width: '70px', height: '70px' }"
        strokeWidth="5"
        styleClass="spinner"
    ></p-progressSpinner>
</div>
